import { jsx as _jsx } from "react/jsx-runtime";
import { NPCModalForm } from '../EntityModalForms/NPCModalForm';
import './EditNPCModal.scss';
function EditNPCModal({ isOpen, onClose, onUpdate, npc, isLoading }) {
    return (_jsx(NPCModalForm, { isOpen: isOpen, onClose: onClose, onSubmit: onUpdate, isLoading: isLoading, mode: "edit", npc: npc, title: "Edit NPC", submitIdleLabel: "Update NPC", submitBusyLabel: "Updating..." }));
}
export default EditNPCModal;
